// extracted by mini-css-extract-plugin
module.exports = {"ellip2":"Ellipse_ellip2__2lhhA","imgcircu":"Ellipse_imgcircu__1BJq9"};